export function mergeConversationMessagesForDisplay(previousRows = [], incomingRows = []) {
  const rowsById = new Map();

  for (const row of previousRows) {
    if (!row?.id) continue;
    rowsById.set(row.id, row);
  }

  for (const row of incomingRows) {
    if (!row?.id) continue;
    rowsById.set(row.id, {
      ...(rowsById.get(row.id) || {}),
      ...row,
    });
  }

  return [...rowsById.values()].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
}

export function resolveLatestValidProfileName(rows = []) {
  for (let index = rows.length - 1; index >= 0; index -= 1) {
    const value = rows[index]?.profile_name;
    if (typeof value !== "string") continue;

    const candidate = value.trim();
    if (!candidate || candidate.toLowerCase() === "not available") continue;

    return candidate;
  }

  return "";
}
